<template>
    <div class="container-fluid">
        <div class="col-12 text-center" v-if="inFetching" style="margin-top: 25%">
            <div class="spinner-grow text-green" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-else>
            <header-component></header-component>
            <top-slider-component></top-slider-component>
            <router-view></router-view>
            <footer-component></footer-component>
        </div>
    </div>
</template>

<script>
    /**
     * Import components
     */
    import HeaderComponent from './blocks/HeaderComponent';
    import TopSliderComponent from './blocks/TopSliderComponent';
    import FooterComponent from './blocks/FooterComponent';

    export default {
        name: "CustomersMainComponent",
        components: {
            HeaderComponent,
            TopSliderComponent,
            FooterComponent
        },
        data() {
            return {
                inFetching: true
            }
        },
        async mounted() {
            // get configurations
            await this.$store.dispatch('getAllConfigurations');

            // get all sliders list
            await this.$store.dispatch('getAllSlidersList');

            // get news list
            await this.$store.dispatch('getNewsList');

            // release inFetching mode
            this.inFetching = false;
        }
    }
</script>

<style scoped>

</style>
